import { render, staticRenderFns } from "./TradeGuide.vue?vue&type=template&id=07767656&scoped=true&"
import script from "./TradeGuide.vue?vue&type=script&lang=js&"
export * from "./TradeGuide.vue?vue&type=script&lang=js&"
import style0 from "./TradeGuide.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./TradeGuide.vue?vue&type=style&index=1&id=07767656&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "07767656",
  null
  
)

export default component.exports